<script>
import Label from "../form-components/Label.vue";
import Multiselect from "vue-multiselect";
import * as categoryService from '../../../components/service/category.service';

export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      required: false,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true
    }
  },
  components: {
    Label,
    Multiselect,
  },
  data() {
    return {
      value: [],
      options: [],
      days: {
        mon: { am: 0, pm: 0 },
        tue: { am: 0, pm: 0 },
        wed: { am: 0, pm: 0 },
        thu: { am: 0, pm: 0 },
        fri: { am: 0, pm: 0 },
        sat: { am: 0, pm: 0 },
        sun: { am: 0, pm: 0 },
      },
      display_none_check: this.selectedItem
        ? JSON.stringify(this.selectedItem[this.item.displayOn]) ==
          this.item.displayOnValue
          ? false
          : true
        : true,
    };
  },
  watch: {
    last_updated: {
      handler(val) {
        if (val && this.item.displayOn && val.key == this.item.displayOn) {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        }
      },
      deep: true,
    },
    item_value: {
      handler(val) {
        if (val != this.value) {
          let arr = [];
          for (const item of val) {
            if(item && item.id) {
              arr.push(this.options.filter((x) => x.id == item.id)[0]);
            }
          }
          this.value = arr;
        }
      },
      deep: true,
    },
    value(val) {
      if (val) {
        // const roots = val.map((v) => {
        //   let tempObj = {};
        //   Object.assign(tempObj, { id: v.id });
        //   Object.assign(tempObj, { days: this.days });
        //   Object.assign(tempObj, { status: true });
          // return tempObj;
        // });
        // this.$emit("update-value", this.item_key, val);
        this.updateValue(this.item_key, val);
      }
    },
  },
  methods: {
    async getOptions() {
      let filter = {
        "where": {
          "name": "Locations",
          "cmsId": this.$route.params.cmsId
        },
        "include": [
          {
            "relation": "pages"
          }
        ]
      };

      filter = encodeURIComponent(JSON.stringify(filter));
      
      let data = await categoryService.getWithFilter(filter)
      let pages = data[0].pages;
      if(pages) this.options = pages;

      let arr = [];
      for (const item of this.item_value) {
        if(item && item.id) {
          arr.push(this.options.filter((x) => x.id == item.id)[0]);
        }
      }
      this.value = arr;
    },
  },
  mounted() {
    this.getOptions();
  },
};
</script>
<template>
  <div class="mb-3" :class="{ 'd-none': item.displayOn && !display_none_check }">
    <Label :item="item" />
    <multiselect
      track-by="title"
      label="title"
      v-model="value"
      :options="options"
      :searchable="options.length > 5 ? true : false"
      :close-on-select="true"
      :show-labels="false"
      :placeholder="item.placeholder"
      :allow-empty="true"
      :preselectFirst="true"
      :multiple="true"
    >
      <template slot="singleLabel" slot-scope="{ option }"
        ><strong>{{ option.title }}</strong></template
      >
    </multiselect>
    <div v-if="submitted && validation.$error" class="invalid-feedback">
      <span v-if="!validation.required">This value is required.</span>
    </div>
  </div>
</template>



